module.exports = __webpack_public_path__ + "static/media/levels_5_5.edf71ddd.svg";